import { EVENTS, MODALS } from 'common/domain/constants';
import { MODAL_ACTIONS } from 'food-benefit.module/common/domain/constants';

const DELEGATED_REQUEST_BODY_ID = 'delegatedRequestBody';

class DelegatedRequestModalController {

  constructor
  (
    $scope,
    $rootScope,
    $translate,
    $location,
    foodBenefitService,
    myFoodBenefitHelper,
    FoodBenefitUserDataService,
    EventEmitter,
    loadingMobileService,
    floatingActionButtonsService
  ) 
  {
    'ngInject';
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.translate = $translate;
    this.location = $location;
    this.EventEmitter = EventEmitter;
    this.foodBenefitService = foodBenefitService;
    this.floatingActionButtonsService = floatingActionButtonsService;
    this.myFoodBenefitHelper = myFoodBenefitHelper;
    this.cardModified = false;
    this.UserDataService = FoodBenefitUserDataService;
    this.employee = this.UserDataService.getEmployee();
    this.userId = this.employee.userId;
    this.loadingMobileService = loadingMobileService;
  }

  $onInit() {
    this.employeeFormattedToCard = [this.employeeToEdit];
    this.employeeInitialValues = angular.copy(this.employeeToEdit);
    this._translate();
    if (this.isMobileApp) {
      this.floatingActionButtons = this.myFoodBenefitHelper.getFloatingSendAllButton();
    }
    this.scope.$watch(() => this.employeeToEdit, (newValue) => {
      if (newValue) {
        this.employeeFormattedToCard = [newValue];
        this.employeeInitialValues = angular.copy(newValue);
      }
    });
  }

  get modalBenefitRequestList() {
    return $(MODALS.BENEFIT_DELEGATED_REQUEST_LIST);
  }

  get modalDelegatedRequest() {
    return $(MODALS.DELEGATED_REQUEST_MODAL);
  }

  openModalRequestAll() {
    this.countModifiedCards = this.modifiedArray.length;
    this.modalState = this.myFoodBenefitHelper.getModalStateSendAll();
    this.modalBenefitRequestList.modal('show');
  }

  _hideRequestModal() {
    this.modalBenefitRequestList.modal('hide');
  }

  hideSelfModal() {
    let cardsAreNotSended = this.requestModal === undefined;
    this.resetEmployeeEdited();
    let event = this.EventEmitter(this.employeeToEdit);
    if(cardsAreNotSended) {
      event = this.EventEmitter(this.employeeInitialValues);
      this.cardModified = false;
      this.employeeFormattedToCard = [this.employeeInitialValues];
    }
    this.updateEmployee(event);
    this.modalDelegatedRequest.modal('hide');
  }

  onModalResponse($event) {
    this.modalAction = $event.status;
    let cardsToSend = this.modifiedArray.map(this.myFoodBenefitHelper.formatRequest);
    if($event.status === MODAL_ACTIONS.CANCEL) {
      this._hideRequestModal();
      return;
    }
    if($event.status === MODAL_ACTIONS.SEND) {
      this.requestFoodBenefits(cardsToSend, null);
    }
  }

  onModify(modifiedArray) {
    this.modifiedArray = modifiedArray;
    this.cardModified = this.myFoodBenefitHelper.checkMoreThanOneModified(this.modifiedArray);
  }

  onSendCard(card) {
    let arrayToSend = new Array();
    arrayToSend.push(card);
    arrayToSend = arrayToSend.map(this.myFoodBenefitHelper.formatRequest);
    this.requestFoodBenefits(arrayToSend, card);
  }

  requestFoodBenefits(requests, card) {
    this.loadingMobileService.show();
    this.foodBenefitService.requestFoodBenefits(requests, this.userId)
      .then(() => {
        this._reloadData(card, false);
        this.requestModal = requests;
        this.modalMessage = `${requests.length} ${this.allRequestApprovedText}`;
      }).catch((error) => {
        if (card === null) {
          this._showModalErrorWhenFailedSendAllCards(error.data.message);
        } else {
          card.requestErrorMsg = error.data.message;
        }
        this._reloadData(card, true);
      }).finally(() => this.loadingMobileService.hide());
  }

  _getDelegatedEmployeeInfo(mainEmployeeInfo) {
    let currentEmployeeDelegated = mainEmployeeInfo.delegations.find(delegatedEmployee => {
      return delegatedEmployee.profile.employeeId === this.employeeToEdit.profile.employeeId;
    });
    return currentEmployeeDelegated;
  }

  _initData() {
    const mainEmployeeInfo = this.UserDataService.getEmployee();
    const employeeToEdit = this._getDelegatedEmployeeInfo(mainEmployeeInfo);
    let employeesBackup = [];
    employeesBackup.push(employeeToEdit);
    this.employeeFormattedToCard = angular.copy(employeesBackup);
  }

  _reloadData(card, isErrored) {
    this.foodBenefitService.getManagerDataSync()
      .then((managerData) => {
        let requestNumber = managerData.employeesFoodBenefitPeriods.length;
        this.rootScope.$broadcast(EVENTS.BADGE_NUMBER, { badgeNumber: requestNumber });
      });
    this.cardModified = false;
    this.foodBenefitService.getUserDataSync()
      .then(() => {
        this._initData();
        if (isErrored) {
          this.setStateFailed(card);
        } else {
          this.setStateApprove(card);
        }
      });
  }

  resetEmployeeEdited() {
    const mainEmployeeInfo = this.UserDataService.getEmployee();
    this.employeeToEdit = this._getDelegatedEmployeeInfo(mainEmployeeInfo);
  }

  daysIsFocused($event) {
    this.daysInCardIsFocused = $event.isFocused;
    this.scrollToTop();
  }

  scrollToTop() {
    this.location.hash(DELEGATED_REQUEST_BODY_ID);
  }

  showSendAllRequest() {
    return this.isMobileApp && this.cardModified && !this.floatingActionButtonsService.isFocused && !this.daysInCardIsFocused;
  }

  setStateApprove(card) {
    if (card) {
      this.newCardState = this.myFoodBenefitHelper.setCardStateApproved(card, this.employeeFormattedToCard);
    }
    else {
      this.modalState = this.myFoodBenefitHelper.getModalStateApproved();
    }
  }

  setStateFailed(card) {
    if (card) {
      this.newCardState = this.myFoodBenefitHelper.setCardStateFailed(card, this.employeeFormattedToCard);
    }
    else {
      this.modalState = this.myFoodBenefitHelper.getModalStateFailed();
    }
  }

  _showModalErrorWhenFailedSendAllCards(messageError) {
    this.modalMessage = messageError;
    this.modalState = this.myFoodBenefitHelper.getModalStateFailed();
  }

  _translate() {
    return  this.myFoodBenefitHelper.getApproveAllMessage().then((translation) => {
      this.allRequestApprovedText = translation;
    });
  }

}

export default DelegatedRequestModalController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedRequestModal/delegatedRequestModal.controller.js